import { getProductDetail } from "@/fetcher/getProductDetail";
import useSWR from "swr";

type FetcherArgsType = readonly [string, number, number?];

const fetcher = async (args: FetcherArgsType) => {
  return getProductDetail(args[1], args[2]);
};

export const useGetProductDetail = (id: number, limitedProductId?: number) => {
  return useSWR(["/app/product/", id, limitedProductId], fetcher);
};
